/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-11 17:37
 * @LastEditors: 苏梦觎 mengyu.su@ginlong.com
 * @LastEditTime: 2026-04-17 17:45:49
 * @FilePath: \glyun_web_vue3\src\router\operation.js
 * @Description: 运营路由
 */
export default [
  {
    path: '/operation',
    redirect: '/operation/accountManagement/org',
    name: 'operation',
    component: () => import('../views/nav/index.vue'),
    children: [
      {
        //账号管理
        path: 'accountManagement',
        name: 'operationAccountManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //组织管理
            path: 'org',
            name: 'operationAccountManagementOrg',
            component: () => import('../views/operation/accountManagement/org/index.vue'),
            meta: {
              title: 'v2_service_organization_management',
              routeAuthCode: 'A060000',
            },
          },
          {
            //业主管理
            path: 'owner',
            name: 'operationAccountManagementOwner',
            component: () => import('../views/operation/accountManagement/owner/index.vue'),
            meta: {
              title: 'v2_account_management_owner_management',
              routeAuthCode: 'A060001',
            },
          },
          {
            //内部账号
            path: 'internalAccount',
            name: 'operationAccountManagementInternalAccount',
            component: () =>
              import('../views/operation/accountManagement/internalAccount/index.vue'),
            meta: {
              title: 'v2_account_management_internal_account',
              keepAlive: true,
              routeAuthCode: 'A060002',
            },
          },
          {
            //角色管理
            path: 'role',
            name: 'operationAccountManagementRole',
            component: () => import('../views/operation/accountManagement/role/index.vue'),
            meta: {
              title: 'v2_account_management_role_management',
              routeAuthCode: 'A060003',
            },
          },
          {
            //权限管理
            path: 'permission',
            name: 'operationAccountManagementPermission',
            component: () => import('../views/operation/accountManagement/permission/index.vue'),
            meta: {
              title: 'v2_account_management_access_management',
              routeAuthCode: 'A060003',
            },
          },
        ],
      },
      {
        //设备管理
        path: 'deviceManagement',
        name: 'operationDeviceManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //逆变器管理
            path: 'inverter',
            name: 'operationDeviceManagementInverter',
            component: () => import('../views/operation/deviceManagement/inverter/index.vue'),
            meta: {
              title: 'v2_device_management_inverter_management',
              routeAuthCode: 'A060100',
            },
          },
          {
            //电池管理
            path: 'battery',
            name: 'operationDeviceManagementBattery',
            component: () => import('../views/operation/deviceManagement/battery/index.vue'),
            meta: {
              title: 'v2_battery_management',
              routeAuthCode: 'A060107',
            },
          },
          {
            //采集器管理
            path: 'collector',
            name: 'operationDeviceManagementCollector',
            component: () => import('../views/operation/deviceManagement/collector/index.vue'),
            meta: {
              title: 'v2_device_management_datalogger_management',
              routeAuthCode: 'A060101',
            },
          },
          {
            //充电桩管理
            path: 'chargingPile',
            name: 'operationDeviceManagementChargingPile',
            component: () => import('../views/operation/deviceManagement/chargingPile/index.vue'),
            meta: {
              title: 'v2_device_management_charger_management',
              routeAuthCode: 'A060103',
            },
          },
          {
            //epm管理
            path: 'epm',
            name: 'operationDeviceManagementEpm',
            component: () => import('../views/operation/deviceManagement/epm/index.vue'),
            meta: {
              title: 'v2_epm_management',
              routeAuthCode: 'A060108',
            },
          },
          {//电网汇流柜管理
            path: 'gridCabinet',
            name: 'operationDeviceManagementGridCabinet',
            component: () => import('../views/operation/deviceManagement/gridCabinet/index.vue'),
            meta: {
              title: 'v2_grid_cabinet_management',
              routeAuthCode: 'A060109'
            }
          },
          {//SIM卡管理
            path: 'simCard',
            name: 'operationDeviceManagementSimCard',
            component: () => import('../views/operation/deviceManagement/simCard/index.vue'),
            meta: {
              title: 'v2_export_record_sim_card',
              routeAuthCode: 'A060102',
            },
          },
          {
            //SIM卡账期核对
            path: 'simCheck',
            name: 'operationDeviceManagementSimCheck',
            component: () => import('../views/operation/deviceManagement/simCheck/index.vue'),
            meta: {
              title: 'v2_device_management_sim_period_reconciliation',
              routeAuthCode: 'A060105',
            },
          },
          {
            //显示屏管理
            path: 'display',
            name: 'operationDeviceManagementDisplay',
            component: () => import('../views/operation/deviceManagement/display/index.vue'),
            meta: {
              title: 'v2_device_management_screen_management',
              routeAuthCode: 'A060104',
            },
          },
          {
            //OA审批管理
            path: 'oaApprovalManage',
            name: 'operationDeviceManagementoaApprovalManage',
            component: () => import('../views/operation/deviceManagement/oaApprovalManage/index.vue'),
            meta: {
              title: 'v2_oa_approval_mgmt',
              routeAuthCode: 'A060110',
            },
          },
        ],
      },
      {
        //维护管理
        path: 'maintenanceManagement',
        name: 'operationMaintenanceManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //逆变器Model维护
            path: 'inverterModel',
            name: 'operationDeviceManagementInverterModel',
            component: () =>
              import('../views/operation/maintenanceManagement/inverterModel/index.vue'),
            meta: {
              title: 'v2_export_record_inverter_model_maintenance',
              routeAuthCode: 'A060200',
            },
          },
          {//电网汇流柜Model维护
            path: 'gridCabinetModel',
            name: 'operationDeviceManagementGridCabinetModel',
            component: () => import('../views/operation/maintenanceManagement/gridCabinetModel/index.vue'),
            meta: {
              title: 'v2_grid_cabinet_model_maintenance',
              routeAuthCode: 'A060214'
            }
          },
          {
            //故障代码维护
            path: 'faultCode',
            name: 'operationDeviceManagementFaultCode',
            component: () => import('../views/operation/maintenanceManagement/faultCode/index.vue'),
            meta: {
              title: 'v2_export_record_alarm_code_maintenance',
              routeAuthCode: 'A060201',
            },
          },
          {
            //国家标准维护
            path: 'nationalStandard',
            name: 'operationDeviceManagementNationalStandard',
            component: () =>
              import('../views/operation/maintenanceManagement/nationalStandard/index.vue'),
            meta: {
              title: 'v2_export_record_national_standard_maintenance',
              routeAuthCode: 'A060202',
            },
          },
          {
            //国家标准维护(旧)
            path: 'nationalStandardOld',
            name: 'operationDeviceManagementNationalStandardOld',
            component: () =>
              import('../views/operation/maintenanceManagement/nationalStandardOld/index.vue'),
            meta: {
              title: 'v2_export_record_national_standard_maintenance_old',
              routeAuthCode: 'A060202',
            },
          },
          {
            //系列维护
            path: 'series',
            name: 'operationDeviceManagementSeries',
            component: () => import('../views/operation/maintenanceManagement/series/index.vue'),
            meta: {
              title: 'v2_export_record_series_maintenance',
              routeAuthCode: 'A060203',
            },
          },
          {
            //流量套餐管理
            path: 'trafficRechargeManegement',
            name: 'operationDeviceManagementTrafficRechargeManegement',
            component: () =>
              import(
                '../views/operation/maintenanceManagement/trafficRechargegeManegement/index.vue'
              ),
            meta: {
              title: 'v2_data_plan_mgmt',
              routeAuthCode: 'A060204',
            },
          },
          {
            //创建订单
            path: 'createtrafficRechargeManegementOrder',
            name: 'createtrafficRechargeManegementOrder',
            component: () =>
              import(
                '../views/operation/maintenanceManagement/trafficRechargegeManegement/components/createOrder.vue'
              ),
            meta: {
              title: 'v2_service_extend_warranty_create_order',
              // routeAuthCode: 'testCode',
            },
          },
          {
            //电池维护
            path: 'battery',
            name: 'operationDeviceManagementBatteryModel',
            component: () => import('../views/operation/maintenanceManagement/battery/index.vue'),
            meta: {
              title: 'v2_maintenance_BatteryMaintenance',
              routeAuthCode: 'A060206',
            },
          },
          // {//SIM卡定价
          //   path: 'simCardPricing',
          //   name: 'operationDeviceManagementSimCardPricing',
          //   component: () => import('../views/operation/maintenanceManagement/simCardPricing/index.vue'),
          //   meta: {
          //     title: 'v2_maintenance_management_sim_pricing',
          //     routeAuthCode: 'A060204'
          //   }
          // },
          {
            //组件维护
            path: 'componentBrand',
            name: 'operationDeviceManagementComponentBrand',
            component: () =>
              import('../views/operation/maintenanceManagement/componentBrand/index.vue'),
            meta: {
              title: 'v2_export_record_module_maintenance',
              routeAuthCode: 'A060205',
            },
          },
          {
            //采集器固件烧录
            path: 'collectorFirmwareBurn',
            name: 'operationDeviceManagementCollectorFirmwareBurn',
            component: () =>
              import('../views/operation/maintenanceManagement/collectorFirmwareBurn/index.vue'),
            meta: {
              title: 'v2_maintenance_management_datalogger_firmware_burning',
              routeAuthCode: 'A060207',
            },
          },
          {
            //采集器存货编码
            path: 'collectorInventoryCode',
            name: 'operationDeviceManagementCollectorInventoryCode',
            component: () => import('../views/operation/maintenanceManagement/collectorInventoryCode/index.vue'),
            meta: {
              title: 'v2_maintenance_management_collector_inventory_code',
              routeAuthCode: 'A060210'
            }
          },
          {
            //充电桩Model维护
            path: 'chargingPileModel',
            name: 'operationDeviceManagementChargingPileModel',
            component: () =>
              import('../views/operation/maintenanceManagement/chargingPileModel/index.vue'),
            meta: {
              title: 'v2_charger_charger_model_maintenance',
              routeAuthCode: 'A060209',
            },
          },
          // {
          //   //采集器Model维护
          //   path: 'collectorModel',
          //   name: 'operationDeviceManagementCollectorModel',
          //   component: () =>
          //     import('../views/operation/maintenanceManagement/collectorModel/index.vue'),
          //   meta: {
          //     title: 'v2_maintenance_management_datalogger_model_maintenance',
          //     routeAuthCode: 'A060208',
          //   },
          // },
          {
            //电池柜Model维护
            path: 'batteryCabinetModel',
            name: 'operationDeviceManagementBatteryCabinetModel',
            component: () =>
              import('../views/operation/maintenanceManagement/batteryCabinetModel/index.vue'),
            meta: {
              title: 'v2_storage_device_model_maintenance',
              routeAuthCode: 'A060212',
            },
          },
          // 版本功能维护
          {
            path: 'versionFunction',
            name: 'operationDeviceManagementVersionFunction',
            component: () =>
              import('../views/operation/maintenanceManagement/versionFunction/index.vue'),
            meta: {
              title: 'v2_version_function_maintenance',
              routeAuthCode: 'A060213',
            },
          },
        ],
      },
      {
        //生产管理
        path: 'productionManagement',
        name: 'operationProductionManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //老化测试
            path: 'aging',
            name: 'operationProductionManagementAging',
            component: () => import('../views/operation/productionManagement/aging/index.vue'),
            meta: {
              title: 'v2_menu_nowAging',
              routeAuthCode: 'A060300',
            },
          },
        ],
      },
      {
        //订单管理
        path: 'orderManagement',
        name: 'operationOrderManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //流量充值管理
            path: 'dataRecharge',
            name: 'operationOrderManagementDataRecharge',
            component: () => import('../views/operation/orderManagement/dataRecharge/index.vue'),
            meta: {
              title: 'v2_order_management_traffic_recharge_management',
              routeAuthCode: 'A060401',
            },
          },
          {
            //流量充值审核
            path: 'dataRechargeReview',
            name: 'operationOrderManagementDataRechargeReview',
            component: () =>
              import('../views/operation/orderManagement/dataRechargeReview/index.vue'),
            meta: {
              title: 'v2_order_management_traffic_recharge_audit',
              routeAuthCode: 'A060402',
            },
          },
          {
            //SIM卡订单
            path: 'simCard',
            name: 'operationOrderManagementSimCard',
            component: () => import('../views/operation/orderManagement/simCard/index.vue'),
            meta: {
              title: 'v2_device_management_sim_card_orders',
              routeAuthCode: 'A060400',
            },
          },
          // {//SIM卡管理- 详情
          //   path: 'simCardOrderDetail/:id',
          //   name: 'operationOrderManagementSimCardDetail',
          //   component: () => import('../views/service/extendedWarranty/common/orderDetail.vue'),
          //   meta: {
          //     title: 'v2_export_record_sim_card',
          //     routeAuthCode: 'A060102'
          //   }
          // },
          {
            //采集器订单
            path: 'collector',
            name: 'operationOrderManagementCollector',
            component: () => import('../views/operation/orderManagement/collector/index.vue'),
            meta: {
              title: 'v2_order_management_datalogger_orders',
              routeAuthCode: 'A060403',
            },
          },
          {
            //采集器发货记录
            path: 'collectorShipmentRecord',
            name: 'operationOrderManagementCollectorShipmentRecord',
            component: () =>
              import('../views/operation/orderManagement/collectorShipmentRecord/index.vue'),
            meta: {
              title: 'v2_order_management_datalogger_shipment_records',
              routeAuthCode: 'A060404',
            },
          },
          {
            //GPRS采集器换购记录
            path: 'gprsCollectorBarterRecord',
            name: 'operationOrderManagementGprsCollectorBarterRecord',
            component: () =>
              import('../views/operation/orderManagement/gprsCollectorBarterRecord/index.vue'),
            meta: {
              title: 'v2_order_management_gprs_datalogger_exchange_records',
              routeAuthCode: 'A060405',
            },
          },
        ],
      },
      {
        //日志管理
        path: 'logManagement',
        name: 'operationLogManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //启动日志
            path: 'startupLog',
            name: 'operationLogManagementStartupLog',
            component: () => import('../views/operation/logManagement/startupLog/index.vue'),
            meta: {
              title: 'v2_log_management_startup_log',
              routeAuthCode: 'A060502',
            },
          },
          {
            //操作日志
            path: 'operationLog',
            name: 'operationLogManagementOperationLog',
            component: () => import('../views/operation/logManagement/operationLog/index.vue'),
            meta: {
              title: 'v2_plant_details_operation_log',
              routeAuthCode: 'A060503',
            },
          },
          {
            //异常数据
            path: 'abnormalData',
            name: 'operationLogManagementAbnormalData',
            component: () => import('../views/operation/logManagement/abnormalData/index.vue'),
            meta: {
              title: 'v2_log_management_abnormal_data',
              routeAuthCode: 'A060504',
            },
          },
          {
            //迁移记录
            path: 'migrationRecord',
            name: 'operationLogManagementMigrationRecord',
            component: () => import('../views/operation/logManagement/migrationRecord/index.vue'),
            meta: {
              title: 'v2_log_management_migration_record',
              routeAuthCode: 'A060505',
            },
          },
          {
            //质保修改记录
            path: 'warrantyRevisionRecord',
            name: 'warrantyRevisionRecord',
            component: () =>
              import('../views/operation/logManagement/warrantyRevisionRecord/index.vue'),
            meta: {
              title: 'v2_warranty_modification_record',
              routeAuthCode: 'A060506',
            },
          },
        ],
      },
      {
        //系统管理
        path: 'systemManagement',
        name: 'operationSystemManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //消息通知
            path: 'messageNotification',
            name: 'operationSystemManagementMessageNotification',
            component: () =>
              import('../views/operation/systemManagement/messageNotification/index.vue'),
            meta: {
              title: 'v2_system_management_message_notification',
              routeAuthCode: 'A060601',
            },
          },
          {
            //文章管理
            path: 'article',
            name: 'operationSystemManagementArticle',
            component: () => import('../views/operation/systemManagement/article/index.vue'),
            meta: {
              title: 'v2_system_management_article_management',
              routeAuthCode: 'A060602',
            },
          },
          {
            //图片管理
            path: 'picture',
            name: 'operationSystemManagementPicture',
            component: () => import('../views/operation/systemManagement/picture/index.vue'),
            meta: {
              title: 'v2_system_management_picture_management',
              routeAuthCode: 'A060603',
            },
          },
          {
            //应用管理
            path: 'appManagement',
            name: 'operationSystemManagementAppManagement',
            component: () => import('../views/operation/systemManagement/appManagement/index.vue'),
            meta: {
              title: 'v2_system_management_application_management',
              routeAuthCode: 'A060604',
            },
          },
          {
            //系统配置
            path: 'systemConfig',
            name: 'operationSystemManagementSystemConfig',
            component: () => import('../views/operation/systemManagement/systemConfig/index.vue'),
            meta: {
              title: 'v2_system_management_system_configuration',
              routeAuthCode: 'A060605',
            },
          },
        ],
      },
      {
        //质保管理
        path: 'warrantyManagement',
        name: 'operationWarrantyManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //质保检测
            path: 'warrantyDetection',
            name: 'operationWarrantyManagementWarrantyDetection',
            component: () =>
              import('../views/operation/warrantyManagement/warrantyDetection/index.vue'),
            meta: {
              title: 'v2_warranty_management_warranty_test',
              routeAuthCode: 'A060701',
            },
          },
          {
            //延保管理
            path: 'extendedWarranty',
            name: 'operationWarrantyManagementExtendedWarranty',
            component: () =>
              import('../views/operation/warrantyManagement/extendedWarranty/index.vue'),
            meta: {
              title: 'v2_export_record_extended_warranty_management',
              routeAuthCode: 'A060702',
            },
          },
          {
            //延保审核
            path: 'extendedWarrantyReview',
            name: 'operationWarrantyManagementExtendedWarrantyReview',
            component: () =>
              import('../views/operation/warrantyManagement/extendedWarrantyReview/index.vue'),
            meta: {
              title: 'v2_export_record_extended_warranty_review',
              routeAuthCode: 'A060703',
            },
          },
          {
            //申诉管理
            path: 'appeal',
            name: 'operationWarrantyManagementAppeal',
            component: () => import('../views/operation/warrantyManagement/appeal/index.vue'),
            meta: {
              title: 'v2_export_record_appeal_management',
              routeAuthCode: 'A060704',
            },
          },
          {
            //换机登记
            path: 'replacementRegistration',
            name: 'operationWarrantyManagementReplacementRegistration',
            component: () =>
              import('../views/operation/warrantyManagement/replacementRegistration/index.vue'),
            meta: {
              title: 'v2_export_record_change_registration',
              routeAuthCode: 'A060705',
            },
          },
        ],
      },
      {
        //消息管理
        path: 'messageManagement',
        name: 'operationMessageManagement',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //公告消息
            path: 'noticeMessage',
            name: 'operationMessageManagementNoticeMessage',
            component: () => import('../views/operation/messageManagement/noticeMessage/index.vue'),
            meta: {
              title: 'v2_message_management_bulletin_message',
              routeAuthCode: 'A060801',
            },
          },
          {
            //自定义消息
            path: 'customMessage',
            name: 'operationMessageManagementCustomMessage',
            component: () => import('../views/operation/messageManagement/customMessage/index.vue'),
            meta: {
              title: 'v2_message_management_custom_messages',
              routeAuthCode: 'A060802',
            },
          },
          {
            //业务消息
            path: 'businessMessage',
            name: 'operationMessageManagementBusinessMessage',
            component: () =>
              import('../views/operation/messageManagement/businessMessage/index.vue'),
            meta: {
              title: 'v2_message_management_business_message',
              routeAuthCode: 'A060803',
            },
          },
        ],
      },
      {
        //产品延保
        path: 'productExtendedWarranty',
        name: 'operationProductExtendedWarranty',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //延保订单
            path: 'extendedWarrantyOrder',
            name: 'operationProductExtendedWarrantyExtendedWarrantyOrder',
            component: () =>
              import('../views/operation/productExtendedWarranty/extendedWarrantyOrder/index.vue'),
            meta: {
              title: 'v2_extended_warranty_extended_warranty_order',
              routeAuthCode: 'A060902',
            },
          },
          {
            //运营=》延保订单详情
            path: 'extendedWarrantyOrder/orderDetail/:id',
            name: 'operationExtendedWarrantyOrderDetail',
            component: () => import('../views/service/extendedWarranty/common/orderDetail.vue'),
            meta: {
              title: 'v2_early_warning_details',
            },
          },
          {
            //退款申请
            path: 'refundApplyfor',
            name: 'operationProductExtendedWarrantyRefundApplyfor',
            component: () =>
              import('../views/operation/productExtendedWarranty/refundApplyfor/index.vue'),
            meta: {
              title: 'v2_extended_warranty_refund_requests',
              routeAuthCode: 'A060903',
            },
          },
          {
            //退款记录
            path: 'refundRecord',
            name: 'operationProductExtendedWarrantyRefundRecord',
            component: () =>
              import('../views/operation/productExtendedWarranty/refundRecord/index.vue'),
            meta: {
              title: 'v2_extended_warranty_refund_records',
              routeAuthCode: 'A060904',
            },
          },
          {
            //延保记录
            path: 'extendedWarrantyRecord',
            name: 'operationProductExtendedWarrantyExtendedWarrantyRecord',
            component: () =>
              import('../views/operation/productExtendedWarranty/extendedWarrantyRecord/index.vue'),
            meta: {
              title: 'v2_extended_warranty_extended_warranty_records',
              routeAuthCode: 'A060905',
            },
          },
          {
            //产品目录
            path: 'productList',
            name: 'operationProductExtendedWarrantyProductList',
            component: () =>
              import('../views/operation/productExtendedWarranty/productList/index.vue'),
            meta: {
              title: 'v2_extended_warranty_product_catalog',
              routeAuthCode: 'A060901',
            },
          },
        ],
      },
      {
        //第三方服务
        path: 'thirdPartyServices',
        name: 'operationThirdPartyServices',
        // component: () => import('../views/report/powerStationReport/index.vue'),
        children: [
          {
            //安装商授权
            path: 'installerAuthorization',
            name: 'operationThirdPartyServicesInstallerAuthorization',
            component: () =>
              import('../views/operation/thirdPartyServices/installerAuthorization/index.vue'),
            meta: {
              title: 'v2_account_management_installer_authorisation',
              routeAuthCode: 'A061000',
            },
          },
          {
            //安装审核
            path: 'installationReview',
            name: 'operationThirdPartyServicesInstallationReview',
            component: () =>
              import('../views/operation/thirdPartyServices/installationReview/index.vue'),
            meta: {
              title: 'v2_third_party_install_audit',
              routeAuthCode: 'A061001',
            },
          },
        ],
      },
      {
        //Nomination查询
        path: 'nomination',
        name: 'operationNomination',
        component: () => import('../views/operation/nomination/index.vue'),
        meta: {
          title: 'v2_third_party_nomination_enquiry',
          routeAuthCode: 'A0611',
        },
      },
      {
        // 意见反馈管理
        path: 'feedbackManagement',
        name: 'operationFeedbackManagement',
        component: () => import('../views/operation/feedbackManagement/index.vue'),
        meta: {
          title: 'v2_feedback_management',
          routeAuthCode: 'A0613',
        },
      },
      {
        // 意见反馈详情
        path: 'feedbackManagement/detail/:id',
        name: 'operationFeedbackManagementDetail',
        component: () => import('../views/operation/feedbackManagement/detail.vue'),
        meta: {
          title: 'v2_feedback_detail',
          routeAuthCode: 'A061300',
          activeMenu: '/operation/feedbackManagement',
        },
      },
      {
        // 意见反馈处理
        path: 'feedbackManagement/process/:id',
        name: 'operationFeedbackManagementProcess',
        component: () => import('../views/operation/feedbackManagement/process.vue'),
        meta: {
          title: 'v2_feedback_processing',
          routeAuthCode: 'A061302',
          activeMenu: '/operation/feedbackManagement',
        },
      },
    ],
  },
]
